export default __webpack_public_path__ + "static/media/service_product.f6811f9e.png";